// extracted by mini-css-extract-plugin
module.exports = {"staticPageWrapper":"StaticPage_staticPageWrapper__zVQJC","container":"StaticPage_container__9eh7T","title":"StaticPage_title__Ya07v","content":"StaticPage_content__LRjlp"};